export enum StepperStateKey {
  MANUAL_DEPLOY = 0, // ManualDeploy
  MANAGED_DEPLOY = 1, // ManagedDeploy
}
